












































































import { Component, Vue } from 'vue-property-decorator';
import _ from 'lodash';
import { StripeCardElement } from '@stripe/stripe-js';
import { userState, stripeState } from '@/store';
import Steps from '@/components/Steps.vue';
import PlanCard from '@/components/PlanCard.vue';

@Component({ components: { Steps, PlanCard } })
export default class IndexPage extends Vue {
  public selectedPlanId: string = '';

  public get annualPlans() {
    return _.chain(this.filteredPlans)
      .filter((plan: any) => plan.nickname.toLowerCase().includes('annual'))
      .sortBy('amount')
      .reverse()
      .value();
  }

  public get monthlyPlans() {
    return _.chain(this.filteredPlans)
      .filter((plan: any) => plan.nickname.toLowerCase().includes('monthly'))
      .sortBy('amount')
      .reverse()
      .value();
  }

  public get filteredPlans() {
    if (userState.organization.starterPlanOfferExpiryDate) {
      return stripeState.plans;
    }
    return stripeState.plans.filter(
      plan => !plan.nickname.toLowerCase().includes('starter'),
    );
  }

  public get buttonEnabled() {
    return this.selectedPlanId;
  }

  public created() {
    document.title = `${this.$t(this.$route.meta.title)} | Comply`;
  }

  public handleNextStep() {
    stripeState.SET_SELECTED_PLAN_ID(this.selectedPlanId);

    if (userState.organization.paymentMethod === 'CREDIT_CARD') {
      if (stripeState.cards && stripeState.cards[0]) {
        this.$router.push('/payment-method/select/credit-card');
      } else {
        this.$router.push('/payment-method/create/credit-card');
      }
    } else if (userState.organization.paymentMethod === 'SEPA_DIRECT_DEBIT') {
      if (stripeState.sepaDirectDebits && stripeState.sepaDirectDebits[0]) {
        this.$router.push('/payment-method/select/sepa-direct-debit');
      } else {
        this.$router.push('/payment-method/create/sepa-direct-debit');
      }
    }
  }
}
